module.exports = __webpack_public_path__ + "static/media/2x1.d0e72aaf.png";